import { Glyph } from '@livecontrol/core-ui';
import { Modal } from '@livecontrol/scheduler/components';
import { Scheduler } from '@livecontrol/scheduler/store';
import nextTick from 'next-tick';
import { useCallback } from 'react';
import type { Event } from '../store';

export const useStart = (clientId: number): ((event: Event) => void) => {
  const [mutation] = Scheduler.Event.useStart(clientId);

  const prompt = Modal.usePrompt();

  return useCallback(
    (event: Event): void => {
      prompt.confirm({
        title: 'Start Live Event?',
        content: <p className="text-muted text-center">Are you sure you want to start this event? <br /> You can begin streaming from your device once you have started the event.</p>,
        icon: (
          <Glyph className='text-white bg-transparent text-primary font-size-28px'>
            <i className="fas fa-video" />
          </Glyph>
        ),
        okay: {
          label: 'Start Event'
          // variant: ''
        },
        onAnswer: (answer: boolean): void => {
          if (answer) {
            nextTick(() => {
              void mutation({
                event
              });
            });
          }
        }
      });
    },
    [mutation, prompt]
  );
};
